import React, { useState } from "react";
import { Link } from "react-router-dom";
// Standalone legal pages are routed separately; do not import here
import { motion } from "framer-motion";
import ScrollytellingInvoice from "../components/Landing/ScrollytellingInvoice";
import LoginScreen from "./LoginScreen";
// Templates carousel asset list (commented out since Templates section is not used)
// const TEMPLATES_TARGET_FILES = ['1-land-inv.jpg', '2-land-inv.jpg', '3-land-inv.jpg'];

export default function LandingPage() {
  const [showLogin, setShowLogin] = useState(false)
  return (
    <div
      className="min-h-screen bg-white text-gray-900"
      style={{
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <header className="sticky top-0 z-30 w-full backdrop-blur supports-[backdrop-filter]:bg-white/70 bg-white/80 border-b border-gray-99">
        <div className="mx-auto max-w-7xl px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Link
              to="/"
              aria-label="Go to home"
              onClick={() =>
                window.scrollTo({ top: 0, behavior: "smooth" })
              }
            >
              <img src="/logislip.png" alt="Logislip" className="h-8 md:h-9 lg:h-10 w-auto object-contain cursor-pointer" />
            </Link>
          </div>
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium">
            <a href="#features" className="text-gray-600 hover:text-gray-900">How it works</a>
            <a href="#faq" className="text-gray-600 hover:text-gray-900">FAQ</a>
            <a href="#contact" className="text-gray-600 hover:text-gray-900">Contact</a>
          </nav>
          <div className="flex items-center gap-3">
            <button
              onClick={() => setShowLogin(true)}
              className="hidden sm:inline-flex items-center rounded-md px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900"
            >
              Sign in
            </button>
            <button
              onClick={() => setShowLogin(true)}
              className="inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
            >
              Start free
            </button>
          </div>
        </div>
      </header>

      <main>
        <ScrollytellingInvoice onStartFree={() => setShowLogin(true)} />

        <section className="bg-white">
          <div className="mx-auto max-w-7xl px-6 py-20">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl p-8 md:p-12 text-center text-white"
            >
              <h3 className="text-2xl md:text-3xl font-bold mb-4">Ready to simplify your workflow?</h3>
              <p className="text-blue-100 mb-8 text-lg max-w-2xl mx-auto">
                Join thousands of businesses who have simplified their GST compliance with one-click filing system.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={() => setShowLogin(true)}
                  className="inline-flex items-center justify-center gap-2 bg-white text-blue-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-50 transition transform hover:scale-105"
                >
                  Start Free Trial
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </button>
                <a
                  href="#contact"
                  className="inline-flex items-center justify-center gap-2 border-2 border-white/30 bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full font-semibold hover:bg-white/20 transition"
                >
                  Request Demo
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </a>
              </div>
            </motion.div>
          </div>
        </section>

        {/* TEMPLATES SECTION - COMMENTED OUT
        <section id="templates" className="bg-gray-100 text-black">
          <div className="mx-auto max-w-7xl px-6 py-24">
            <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
              <div>
                <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight">Templates</h2>
                <p className="mt-4 text-black-300 max-w-xl">
                  Choose from Default, Modern, and Formal templates. Pro+ plans unlock all templates and Drive export.
                </p>
                <div className="mt-8 grid grid-cols-3 gap-3 text-center text-sm">
                  {['Default', 'Modern', 'Formal'].map((name) => (
                    <div key={name} className="rounded-xl bg-white/5 border border-gray-500/80 px-3 py-2">
                      {name}
                    </div>
                  ))}
                </div>
              </div>
              <TemplatesCarousel />
            </div>
          </div>
        </section>
        */}

        <section id="faq" className="bg-white">
          <div className="mx-auto max-w-5xl px-6 py-20">
            <h2 className="text-center text-2xl sm:text-3xl font-semibold tracking-tight">FAQ</h2>
            <div className="mt-8 divide-y divide-gray-200 border border-gray-200 rounded-2xl overflow-hidden">
              {[
                {
                  q: "How does one-click GST filing work?",
                  a:
                    "Our system automatically aggregates your invoices and converts them to GSTR-1 and GSTR-3B format. With direct GST portal integration, you can file returns in just one click. The system handles all calculations, validations, and formatting automatically.",
                },
                {
                  q: "Is the GST filing completely compliant and secure?",
                  a:
                    "Yes, we use government-approved APIs for direct integration with the GST portal. All data is encrypted, and our system follows the latest GST regulations. Your credentials are stored securely and never shared with third parties.",
                },
                {
                  q: "How do backups and Google Drive sync work?",
                  a:
                    "You can export/import full backups anytime. With Pro and Business plans, invoices can auto‑sync to your Google Drive (every 30–5 minutes depending on plan). We use your own Google account—tokens are stored locally and can be revoked at any time.",
                },
                {
                  q: "Can I share invoices directly?",
                  a:
                    "Yes. Send invoices with a PDF attachment via Gmail, share a Drive link after export, or send details over WhatsApp in one tap. Email attachments require viewing an invoice to generate a PDF.",
                },
                {
                  q: "What happens if I need help with GST filing?",
                  a:
                    "We provide comprehensive support for GST automation. Our system includes built-in validation, error checking, and detailed reports. Plus, our support team is available to help with any GST compliance questions.",
                },
              ].map((item) => (
                <details key={item.q} className="group p-6 open:bg-gray-50">
                  <summary className="flex cursor-pointer list-none items-center justify-between text-sm font-medium text-gray-900">
                    {item.q}
                    <span className="ml-4 text-gray-500 group-open:rotate-180 transition">⌄</span>
                  </summary>
                  <p className="mt-3 text-sm text-gray-600">{item.a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="bg-gray-50">
          <div className="mx-auto max-w-7xl px-6 py-20">
            <div className="grid gap-12 lg:grid-cols-2 lg:items-start">
              <div>
                <div>
                  <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-900">Get in touch</h2>
                  <p className="mt-4 text-gray-600 max-w-xl">
                    Have questions about LogiSlip? Need help with your invoicing workflow? We'd love to hear from you.
                  </p>
                  
                  <div className="mt-6 flex flex-col sm:flex-row gap-3">
                    <a
                      href="https://wa.me/919535354685?text=Hi%2C%20I%20have%20a%20question%20about%20LogiSlip"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 transition-colors"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                      </svg>
                      WhatsApp
                    </a>
                    
                    <a
                      href="tel:+919535354685"
                      className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                      Call Now
                    </a>
                  </div>
                  
                  <div className="mt-8 space-y-4">
                    <div className="flex items-center gap-3">
                      <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                        <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <span className="text-gray-600">We'll respond within 12 hours</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                        <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <span className="text-gray-600">Support for all plans</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:mt-0">
                <ContactForm />
              </div>

              {/* PREFER EMAIL SECTION - COMMENTED OUT
              <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900">Prefer email?</h3>
                <p className="mt-2 text-sm text-gray-600">
                  Drop us a message and we will get back within 12 hours. You can also reach out directly via WhatsApp or phone using the shortcuts on the left.
                </p>
                <ul className="mt-6 space-y-3 text-sm text-gray-700">
                  <li><span className="font-semibold">Support:</span> hello@logislip.com</li>
                  <li><span className="font-semibold">Sales:</span> sales@logislip.com</li>
                </ul>
              </div>
              */}
            </div>
          </div>
        </section>
      </main>

      {/* Legal sections removed; links open standalone pages */}

      {/* Login modal */}
      {showLogin && (
        <div className="fixed inset-0 z-50">
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setShowLogin(false)} />
          <div className="relative z-10 flex items-center justify-center min-h-screen p-4">
            <div className="w-full max-w-md">
              <EmbeddedLogin onClose={() => setShowLogin(false)} />
            </div>
          </div>
        </div>
      )}

      <footer className="bg-white border-t border-gray-100">
        <div className="mx-auto max-w-7xl px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">© {new Date().getFullYear()} LogiSlip. All rights reserved.</p>
          <div className="flex items-center gap-4 text-sm">
            <Link to="/privacy-policy" className="text-gray-600 hover:text-gray-900">Privacy</Link>
            <Link to="/terms-of-service" className="text-gray-600 hover:text-gray-900">Terms</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}



// TEMPLATES CAROUSEL COMPONENT - COMMENTED OUT (not used since Templates section is commented out)
/*
function TemplatesCarousel() {
  // Filenames expected to exist; we'll resolve at runtime and inline as data URLs for reliability
  const [images, setImages] = useState([])
  const [index, setIndex] = useState(0)

  // Resolve URLs from common public paths and inline as base64 once loaded
  useEffect(() => {
    const basePaths = [
      `${process.env.PUBLIC_URL || ''}/`,
      `${process.env.PUBLIC_URL || ''}/images/`,
      '/',
      '/images/',
    ]

    const probeImage = (url) =>
      new Promise((resolve) => {
        const img = new Image()
        img.onload = () => resolve(url)
        img.onerror = () => resolve(null)
        img.src = url
      })

    const toDataUrl = async (url) => {
      try {
        const res = await fetch(url)
        if (!res.ok) return url
        const blob = await res.blob()
        return await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        })
      } catch {
        return url
      }
    }

    const resolveAll = async () => {
      const resolved = []
      for (const file of TEMPLATES_TARGET_FILES) {
        let found = null
        for (const base of basePaths) {
          // Avoid duplicate slashes
          const candidate = `${base}${file}`.replace(/\/+/, '/').replace(':/', '://')
          // eslint-disable-next-line no-await-in-loop
          const ok = await probeImage(candidate)
          if (ok) {
            found = ok
            break
          }
        }
        // Inline as data URL when possible
        // eslint-disable-next-line no-await-in-loop
        const finalUrl = found ? await toDataUrl(found) : null
        if (finalUrl) resolved.push(finalUrl)
      }
      if (resolved.length > 0) setImages(resolved)
    }

    resolveAll()
  }, [])

  useEffect(() => {
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % images.length)
    }, 3500)
    return () => clearInterval(t)
  }, [images.length])

  // Compute neighbors for a 3-card focus layout
  const leftIdx = images.length ? (index - 1 + images.length) % images.length : 0
  const rightIdx = images.length ? (index + 1) % images.length : 0

  const cards = [leftIdx, index, rightIdx]

  return (
    <div className="relative h-60 sm:h-72 md:h-80 overflow-visible">
      <div className="absolute inset-0 flex items-center justify-center">
        {images.length > 0 && cards.map((idx, pos) => {
          const isCenter = pos === 1
          const baseX = pos === 0 ? -150 : pos === 2 ? 150 : 0
          const baseScale = isCenter ? 1 : 0.85
          const baseOpacity = isCenter ? 1 : 0.6
          const z = isCenter ? 20 : 10

          return (
            <motion.div
              key={`card-${idx}`}
              className="absolute rounded-xl overflow-hidden bg-white/5 border border-white/10"
              initial={{ x: baseX, scale: baseScale, opacity: baseOpacity }}
              animate={{ x: baseX, scale: baseScale, opacity: baseOpacity }}
              transition={{ type: 'spring', stiffness: 120, damping: 18 }}
              style={{ width: 180, height: 240, zIndex: z }}
            >
              <img src={images[idx]} alt="Invoice preview" className="w-full h-full object-cover" />
            </motion.div>
          )
        })}
      </div>
    </div>
  )
}
*/

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: process.env.REACT_APP_WEB3FORMS_ACCESS_KEY,
          ...formData,
          from_name: formData.name,
          subject: `LogiSlip Contact from ${formData.name}`,
        }),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Your name"
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="your@email.com"
            />
          </div>
        </div>
        
        <div>
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
            Phone Number
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            required
            value={formData.phone}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="+91-9876543210"
          />
        </div>
        
        <div>
          <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            required
            rows={5}
            value={formData.message}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
            placeholder="Tell us more about your question or feedback..."
          />
        </div>

        {submitStatus === 'success' && (
          <div className="p-4 bg-green-50 border border-green-200 rounded-md">
            <div className="flex">
              <div className="ml-3">
                <p className="text-sm text-green-800">
                  Thank you! Your message has been sent successfully. We'll get back to you soon.
                </p>
              </div>
            </div>
          </div>
        )}

        {submitStatus === 'error' && (
          <div className="p-4 bg-red-50 border border-red-200 rounded-md">
            <div className="flex">
              <div className="ml-3">
                <p className="text-sm text-red-800">
                  Sorry, there was an error sending your message. Please try again.
                </p>
              </div>
            </div>
          </div>
        )}

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-blue-600 text-white py-3 px-6 rounded-md font-semibold hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition"
        >
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </motion.div>
  );
}

function EmbeddedLogin({ onClose }) {
  return (
    <div>
      <div className="flex justify-end">
        <button onClick={onClose} className="p-1 text-gray-500 hover:text-gray-700" aria-label="Close login">
          ✕
        </button>
      </div>
      <LoginScreen embedded />
    </div>
  )
}

// Removed embedded legal sections
